"use client";

import { SUPPORTED_EXCHANGES } from "@cede/types";
import { API_ENDPOINT } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { useQuery } from "@tanstack/react-query";

type FeeTierResponse = {
  tier: number;
  makerFee: number;
  takerFee: number;
} | null;

type UseFeeTierParams = {
  exchangeId: string;
  exchangeAccountId: number | null;
};

/**
 * Fetches the user's current fee tier from the backend.
 * Enabled for exchanges that support fee tier lookups (GRVT, ZeroOne).
 */
export function useFeeTier(params: UseFeeTierParams) {
  const { auth } = useHubUser();
  const apiHelper = useApi();

  const { exchangeId, exchangeAccountId } = params;
  const supportsFeeTier = exchangeId === SUPPORTED_EXCHANGES.GRVT || exchangeId === SUPPORTED_EXCHANGES.ZEROONE;
  const enabled = supportsFeeTier && exchangeAccountId != null;

  return useQuery<FeeTierResponse>({
    queryKey: ["airdrop-farming", "fee-tier", exchangeId, exchangeAccountId],
    queryFn: () => {
      return apiHelper.getWithAuth(auth, API_ENDPOINT.HUB_AIRDROP_FARMING_FEE_TIER, {
        queryParams: {
          exchangeId,
          exchangeAccountId: String(exchangeAccountId),
        },
      });
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
